module.exports = __webpack_public_path__ + "img/truebill.d96d7d6f.jpg";